import { initLogger } from '../../../logger.js';
import { runSpectralValidations } from '../validation-helpers.js';
import { ValidationPhase } from '../validation-rule.js';
/**
 * A {@link ValidationRule} backed by a Spectral ruleset. This is the "Spectral implementation" of
 * the two-implementation design: declarative JSONPath rules over the raw JSON document.
 */
export class SpectralValidationRule {
    constructor(id, description, ruleset, source, selectDocument, applies) {
        this.id = id;
        this.description = description;
        this.ruleset = ruleset;
        this.source = source;
        this.selectDocument = selectDocument;
        this.applies = applies;
        this.phase = ValidationPhase.LINT;
    }
    appliesTo(context) {
        return this.applies(context) && this.selectDocument(context) !== undefined;
    }
    async run(context) {
        const logger = initLogger(context.debug, 'calm-validate');
        const document = this.selectDocument(context);
        const result = await runSpectralValidations(document, this.ruleset, this.source, logger);
        return {
            jsonSchemaOutputs: [],
            spectralOutputs: result.spectralIssues,
            hasErrors: result.errors,
            hasWarnings: result.warnings
        };
    }
}
//# sourceMappingURL=spectral-rule.js.map